import { Input, InputRef } from 'antd';
import throttle from 'lodash/throttle';
import * as React from 'react';
import { BCNotification, findMessage } from '..';
import Styles from './assets/styles.scss';
import { IInputChangeEventArgs, IInputProps, InputSizes } from './entities';
import IRegExp from './entities/IRegExp';

const BCInput = React.forwardRef<InputRef, IInputProps>(function BCInput(props, ref) {
	Styles;

	const isFirstLoad = React.useRef(true);
	const [value, setValue] = React.useState(props.defaultValue ?? props.value ?? '');

	React.useEffect(() => {
		if (!isFirstLoad.current && value !== props.value) {
			setValue(props.value);
		}
		isFirstLoad.current = false;
	}, [props.value]);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (validationControl(e.currentTarget.value, props.regExp)) {
			return showValidationError(props.regExp.validationFailedMessage);
		}

		setValue(props.isMaskInput ? props.value : e.currentTarget.value);

		props.onChange?.({
			senderArgs: e,
			data: e.currentTarget.value,
			itemKey: props.itemKey
		});
	};

	return (
		<Input
			title={props.title}
			tabIndex={props.tabIndex}
			prefix={props.prefix}
			disabled={props.disabled}
			readOnly={props.readOnly}
			size={props.size}
			style={props.style}
			styles={{ input: { textAlign: props.textAlign } }}
			placeholder={props.placeHolder}
			value={value}
			maxLength={props.maxLength}
			className={props.className}
			onPressEnter={props.onPressEnter}
			onKeyDown={props.onKeyDown}
			type={props.type}
			addonBefore={props.addonBefore}
			addonAfter={props.addonAfter}
			onClick={props.onClick}
			suffix={props.suffix}
			allowClear={props.allowClear}
			autoFocus={props.autoFocus}
			formNoValidate
			autoComplete={props.autoComplete}
			showCount={props.showCount}
			ref={ref}
			onChange={onChange}
			onBlur={props.onBlur}
			onFocus={e => props.onFocus?.({ senderArgs: e, data: e.currentTarget.value })}
			data-selenium-id={props.seleniumId}
		/>
	);
});

const validationControl = (candidate?: string, regExp?: IRegExp): boolean => {
	if (regExp && candidate) {
		const isOK = candidate.match(regExp.regExpString);
		if (!isOK) {
			return true;
		}
	}
	return false;
};

const showValidationError = throttle((description: string = findMessage.get('101313')) => {
	BCNotification.error({ message: findMessage.get('101291'), description });
}, 2500);

export default BCInput;
export { InputRef as BCInputRef, IInputChangeEventArgs, IInputProps, InputSizes, IRegExp };
